/* ==========================================================================
# PLP/Search Results Sticky Filters
========================================================================== */

// Debounce utility for resize events
const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

const initStickyFilters = () => {
  const filtersElement = document.querySelector("[data-collection-filters]");
  if (!filtersElement) return;

  const headerElement = document.querySelector(
    "header.sticky-header"
  ).parentElement;
  const setStickyFiltersTop = () => {
    const headerHeight = headerElement ? headerElement.offsetHeight : 0;
    filtersElement.style.top = `${headerHeight}px`;
  };
  setStickyFiltersTop();

  window.addEventListener("resize", debounce(setStickyFiltersTop, 100));
};
initStickyFilters();